import React from "react";
import "./callWindow.css";
import { getLucideIcon } from "@/utils/icon-mapper";
import { LucideIcon } from "lucide-react";

interface CallHintsDisplayProps {
  callHints?: any[];
  callHintsTable?: any[];
}

const CallHintsDisplay: React.FC<CallHintsDisplayProps> = ({
  callHints,
  callHintsTable
}) => {
  const getIconComponent = (icon: string | LucideIcon): LucideIcon | null => {
    if (!icon) return null;
    if (typeof icon === "string") return getLucideIcon(icon);
    return icon;
  };

  return (
    <>
      {callHints && callHints.length > 0 && (
        <div className="verificationinfo">
          {callHints.map((hint: any, index: any) => {
            const IconComponent = getIconComponent(hint.icon);
            return (
              <div key={index} className="infodate">
                <div
                  className="mr-8"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <b>
                    {IconComponent && (
                      <span style={{ display: "inline-flex", flexShrink: 0 }}>
                        <IconComponent
                          style={{
                            opacity: 0.6,
                            marginRight: "5px",
                            marginTop: "3px"
                          }}
                          size={15}
                        />
                      </span>
                    )}{" "}
                    <span style={{ whiteSpace: "nowrap" }}>{hint.name}</span>
                  </b>
                </div>
                <p
                  style={{
                    width: "100%",
                    wordWrap: "break-word",
                    textAlign: "right"
                  }}
                >
                  {hint.value}
                </p>
              </div>
            );
          })}
        </div>
      )}

      {callHintsTable && callHintsTable.length > 0 && (
        <div className="verificationinfo">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                {Object.keys(callHintsTable[0]).map((header) => (
                  <th key={header} className="border p-2 px-6 capitalize">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {callHintsTable.map((row: any, index: number) => (
                <tr key={index}>
                  {Object.values(row).map((value: any, cellIndex: number) => (
                    <td key={cellIndex} className="border p-2">
                      {value}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default CallHintsDisplay;
